import { post } from '../actions/ajax';
import store from '../reducers/storeRegistration';
import loginActions from '../actions/loginActionCreators';

// Simple mapping from entity name to route - avoids circular dependency
const getEntityRoute = entityName => {
  switch (entityName) {
    case 'Creator':
      return 'employees';
    case 'ContractSpec':
      return 'contractspecs';
    case 'JobPhaseCode':
      return 'jobphasecodes';
    case 'contentChange':
      return 'contentChanges';
    case 'formModal':
      return 'forms';
    default:
      return "".concat(entityName.toLowerCase(), "s");
  }
};
const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext
/* nativeFunctions, */) => {
  const entityRoute = getEntityRoute(entityName);
  const url = "/".concat(entityRoute, "/evaluate");

  // Reduce the content and entity size when making a server request
  // Ideally, content and entity would be further reduced to only the necessary data, but
  // it's challenging to determine what is necessary for the server to evaluate the behavior.
  const limitedEntity = JSON.parse(JSON.stringify(entity));
  delete limitedEntity.content;
  const limitedContent = JSON.parse(JSON.stringify(content));
  const types = ['formType', 'issueType', 'ReportType'];
  types.forEach(type => {
    if (limitedContent[type]) {
      const dataToKeep = {
        name: limitedContent[type].name,
        identifier: limitedContent[type].identifier
      };
      delete limitedContent[type];
      limitedContent[type] = dataToKeep;
    }
    delete limitedEntity[type]; // remove type from entity too
  });
  const postData = {
    source,
    content: limitedContent,
    entity: limitedEntity,
    parentContentPath,
    transientContext
  };
  try {
    const response = await post(url, postData);
    return response.data;
  } catch (e) {
    var _e$response;
    // If token expired (401), refresh and retry once
    if (((_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 401) {
      await store.dispatch(loginActions.serverToken());
      const response = await post(url, postData);
      return response.data;
    }
    // Re-throw so the caller's error handling can respond
    throw e;
  }
};
const serverNativeBehaviorEvaluator = {
  evaluate
};
export default serverNativeBehaviorEvaluator;